import type { DefaultOptionType } from 'antd/es/select';

export const ELEMENT_PRACTICE_QUESTIONS_TO_SELECT = 'practiceQuizQuestionsToSelect';
export const QUESTIONS_TO_SELECT = 'questionsToSelect';

export const ELEMENT_FINAL_QUESTIONS_TO_SELECT = 'finalQuizQuestionsToSelect';
export const TIME_IN_SECONDS_PER_QUESTION = 'timeInSecondsPerQuestion';

export const DEFAULT_TIME_IN_SECONDS_PER_QUESTION = 60;

export const getQuestionsOptions = (count: number): DefaultOptionType[] =>
    Array.from({ length: count + 1 }, (_, i) => ({
        label: i,
        value: i,
    }));

export const TIME_LIMITS: DefaultOptionType[] = [
    { label: 30, value: 30 },
    { label: 60, value: 60 },
    { label: 90, value: 90 },
    { label: 120, value: 120 },
];
